module.exports = __webpack_public_path__ + "img/normal-login.6913ef03.png";